export default __webpack_public_path__ + "static/char-15-anr-cf563ed9c433561d51385e5d1c1f2659.webp";